export function openUrlsInNewTabs(urls: string[]): {
  openedCount: number;
  blockedUrls: string[];
} {
  const uniqueUrls = [...new Set(urls.filter(Boolean))];
  const stamp = Date.now();
  const blockedUrls: string[] = [];
  let openedCount = 0;

  const tabs = uniqueUrls.map((_, index) =>
    window.open("about:blank", `open-link-${stamp}-${index}`)
  );

  uniqueUrls.forEach((url, index) => {
    const tab = tabs[index];
    if (!tab) {
      blockedUrls.push(url);
      return;
    }

    tab.location.replace(url);
    tab.opener = null;
    openedCount += 1;
  });

  return { openedCount, blockedUrls };
}
